import { InstagramAccount, InstagramTarget, Plan, DailyStats } from '../types';

export const instagramAccounts: InstagramAccount[] = [
  {
    id: 1,
    name: 'Sarah Martin',
    username: '@sarahcreative',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
    isActive: true,
    followers: '12.5K',
    engagement: '4.8%',
    posts: 248,
    plan: 'Amplr Pro',
    initial_followers: 10000,
    actual_followers: 12500,
    follower_gained: 2500,
    followerHistory: [
      { date: '2024-03-01', count: 10000, gains: 0 },
      { date: '2024-03-02', count: 10500, gains: 500 },
      { date: '2024-03-03', count: 11000, gains: 1000 },
      { date: '2024-03-04', count: 11200, gains: 1200 },
      { date: '2024-03-05', count: 11500, gains: 1500 },
      { date: '2024-03-06', count: 11800, gains: 1800 },
      { date: '2024-03-07', count: 12000, gains: 2000 },
      { date: '2024-03-08', count: 12200, gains: 2200 },
      { date: '2024-03-09', count: 12500, gains: 2500 },
    ],
  },
  {
    id: 2,
    name: 'Thomas Anderson',
    username: '@digital.thomas',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop',
    isActive: true,
    followers: '8.2K',
    engagement: '3.9%',
    posts: 156,
    plan: 'Amplr Start',
    initial_followers: 5000,
    actual_followers: 8200,
    follower_gained: 3200,
    followerHistory: [
      { date: '2024-03-01', count: 5000, gains: 0 },
      { date: '2024-03-02', count: 5500, gains: 500 },
      { date: '2024-03-03', count: 6000, gains: 1000 },
      { date: '2024-03-04', count: 6500, gains: 1500 },
      { date: '2024-03-05', count: 7000, gains: 2000 },
      { date: '2024-03-06', count: 7500, gains: 2500 },
      { date: '2024-03-07', count: 7800, gains: 2800 },
      { date: '2024-03-08', count: 8000, gains: 3000 },
      { date: '2024-03-09', count: 8200, gains: 3200 },
    ],
  },
  {
    id: 3,
    name: 'Emma Wilson',
    username: '@emmaphotography',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop',
    isActive: false,
    followers: '25.1K',
    engagement: '5.2%',
    posts: 412,
    plan: 'Amplr Max',
    initial_followers: 20000,
    actual_followers: 25100,
    follower_gained: 5100,
    followerHistory: [
      { date: '2024-03-01', count: 20000, gains: 0 },
      { date: '2024-03-02', count: 21000, gains: 1000 },
      { date: '2024-03-03', count: 22000, gains: 2000 },
      { date: '2024-03-04', count: 22500, gains: 2500 },
      { date: '2024-03-05', count: 23000, gains: 3000 },
      { date: '2024-03-06', count: 23500, gains: 3500 },
      { date: '2024-03-07', count: 24000, gains: 4000 },
      { date: '2024-03-08', count: 24500, gains: 4500 },
      { date: '2024-03-09', count: 25100, gains: 5100 },
    ],
  },
  {
    id: 4,
    name: 'David Chen',
    username: '@davidtech',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop',
    isActive: true,
    followers: '15.7K',
    engagement: '4.1%',
    posts: 287,
    plan: 'Amplr Pro',
    initial_followers: 12000,
    actual_followers: 15700,
    follower_gained: 3700,
    followerHistory: [
      { date: '2024-03-01', count: 12000, gains: 0 },
      { date: '2024-03-02', count: 12500, gains: 500 },
      { date: '2024-03-03', count: 13000, gains: 1000 },
      { date: '2024-03-04', count: 13500, gains: 1500 },
      { date: '2024-03-05', count: 14000, gains: 2000 },
      { date: '2024-03-06', count: 14500, gains: 2500 },
      { date: '2024-03-07', count: 15000, gains: 3000 },
      { date: '2024-03-08', count: 15300, gains: 3300 },
      { date: '2024-03-09', count: 15700, gains: 3700 },
    ],
  },
];

export const suggestedTargets: InstagramTarget[] = [
  {
    id: '1',
    name: 'Marie Laurent',
    username: '@marielaur',
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop',
    followers: '45.2K',
    following: '891',
    posts: 342,
    user_id: '1',
    account_id: 1,
  },
  {
    id: '2',
    name: 'Jean Dubois',
    username: '@jeandubois',
    avatar:
      'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=150&h=150&fit=crop',
    followers: '28.7K',
    following: '445',
    posts: 156,
    user_id: '1',
    account_id: 1,
  },
  {
    id: '3',
    name: 'Sophie Martin',
    username: '@sophiephoto',
    avatar:
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop',
    followers: '92.1K',
    following: '1,023',
    posts: 892,
    user_id: '1',
    account_id: 1,
  },
  {
    id: '4',
    name: 'Lucas Bernard',
    username: '@lucasb',
    avatar:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop',
    followers: '15.4K',
    following: '334',
    posts: 127,
    user_id: '1',
    account_id: 1,
  },
];

export const plans: Plan[] = [
  {
    name: 'Amplr Start',
    priceMonthly: {
      FR: '74€',
      EN: '$74',
      ES: '74€',
      RU: '74€',
    },
    priceAnnual: {
      FR: '532€',
      EN: '$532',
      ES: '532€',
      RU: '532€',
    },
    annualSavings: {
      FR: '356€',
      EN: '$356',
      ES: '356€',
      RU: '356€',
    },
    features: {
      FR: [
        'Résultats en 24 heures',
        'Croissance garantie ou remboursée',
        "Jusqu'à 250 abonnés réels et qualifiés / mois",
        'Interactions automatisées',
        'Statistiques',
        'Assistance (sous 24 heures)',
      ],
      EN: [
        'Results in 24 hours',
        'Growth guaranteed or money back',
        'Up to 250 real and qualified followers / month',
        'Automated interactions',
        'Statistics',
        'Support (within 24 hours)',
      ],
      ES: [
        'Resultados en 24 horas',
        'Crecimiento garantizado o reembolso',
        'Hasta 250 seguidores reales y calificados / mes',
        'Interacciones automatizadas',
        'Estadísticas',
        'Soporte por correo (dentro de 24 horas)',
      ],
      RU: [
        'Результаты через 24 часа',
        'Гарантированный рост или возврат денег',
        'До 250 реальных и целевых подписчиков / месяц',
        'Автоматизированные взаимодействия',
        'Статистика',
        'Поддержка по email (в течение 24 часов)',
      ],
    },
    included: [true, true, true, true, true, true],
  },
  {
    name: 'Amplr Max',
    priceMonthly: {
      FR: '94€',
      EN: '$94',
      ES: '94€',
      RU: '94€',
    },
    priceAnnual: {
      FR: '676€',
      EN: '$676',
      ES: '676€',
      RU: '676€',
    },
    annualSavings: {
      FR: '452€',
      EN: '$452',
      ES: '452€',
      RU: '452€',
    },
    features: {
      FR: [
        'Résultats en 24 heures',
        'Croissance garantie ou remboursée',
        "Jusqu'à 450 abonnés réels et qualifiés / mois",
        'Interactions automatisées [+ Amplr AI Boost]',
        'Welcome DM automatique',
        "Ajout en amis proches (jusqu'à 7 500 abonnés)",
        'Statistiques',
        'Assistance prioritaire (sous 12 heures)',
      ],
      EN: [
        'Results in 24 hours',
        'Growth guaranteed or money back',
        'Up to 450 real and qualified followers / month',
        'Automated interactions [+ Amplr AI Boost]',
        'Automatic Welcome DM',
        'Close friends addition (up to 7,500 followers)',
        'Statistics',
        'Priority support (within 12 hours)',
      ],
      ES: [
        'Resultados en 24 horas',
        'Crecimiento garantizado o reembolso',
        'Hasta 450 seguidores reales y calificados / mes',
        'Interacciones automatizadas [+ Amplr AI Boost]',
        'DM de bienvenida automático',
        'Adición de amigos cercanos (hasta 7,500 seguidores)',
        'Estadísticas',
        'Soporte prioritario (12 horas)',
      ],
      RU: [
        'Результаты через 24 часа',
        'Гарантированный рост или возврат денег',
        'До 450 реальных и целевых подписчиков / месяц',
        'Автоматизированные взаимодействия [+ Amplr AI Boost]',
        'Автоматическое приветственное сообщение',
        'Добавление в близкие друзья (до 7,500 подписчиков)',
        'Статистика',
        'Приоритетная поддержка (12 часов)',
      ],
    },
    included: [true, true, true, true, true, true, true, true],
    popular: true,
  },
  {
    name: 'Amplr Pro',
    priceMonthly: {
      FR: '294€',
      EN: '$294',
      ES: '294€',
      RU: '294€',
    },
    priceAnnual: {
      FR: '2116€',
      EN: '$2116',
      ES: '2116€',
      RU: '2116€',
    },
    annualSavings: {
      FR: '1412€',
      EN: '$1412',
      ES: '1412€',
      RU: '1412€',
    },
    features: {
      FR: [
        'Résultats en 24 heures',
        'Croissance garantie ou remboursée',
        "Jusqu'à 800 abonnés réels et qualifiés / mois",
        'Interactions automatisées [+ Amplr AI Boost]',
        'Welcome DM automatique',
        "Ajout en amis proches (jusqu'à 7 500 abonnés)",
        "Audit vidéo expert (plan d'action personnalisé)",
        '1 appel stratégique / mois',
        'Statistiques',
        'Assitance premium (sous 4 heures, canal privé Slack)',
      ],
      EN: [
        'Results in 24 hours',
        'Growth guaranteed or money back',
        'Up to 800 real and qualified followers / month',
        'Automated interactions [+ Amplr AI Boost]',
        'Automatic Welcome DM',
        'Close friends addition (up to 7,500 followers)',
        'Expert video audit (personalized action plan)',
        '1 strategy call / month',
        'Statistics',
        'Premium support (within 4 hours, private Slack channel)',
      ],
      ES: [
        'Resultados en 24 horas',
        'Crecimiento garantizado o reembolso',
        'Hasta 800 seguidores reales y calificados / mes',
        'Interacciones automatizadas [+ Amplr AI Boost]',
        'DM de bienvenida automático',
        'Adición de amigos cercanos (hasta 7,500 seguidores)',
        'Auditoría de video experta (plan de acción personalizado)',
        '1 llamada estratégica / mes',
        'Estadísticas',
        'Soporte premium (4 horas, canal privado de Slack)',
      ],
      RU: [
        'Результаты через 24 часа',
        'Гарантированный рост или возврат денег',
        'До 800 реальных и целевых подписчиков / месяц',
        'Автоматизированные взаимодействия [+ Amplr AI Boost]',
        'Автоматическое приветственное сообщение',
        'Добавление в близкие друзья (до 7,500 подписчиков)',
        'Экспертный видео-аудит (персонализированный план действий)',
        '1 стратегический звонок / месяц',
        'Статистика',
        'Премиум-поддержка (4 часа, приватный канал в Slack)',
      ],
    },
    included: [true, true, true, true, true, true, true, true, true, true],
  },
];

export const dailyStats: DailyStats[] = [
  { date: '2024-03-01', followers: 12100 },
  { date: '2024-03-02', followers: 12350 },
  { date: '2024-03-03', followers: 12420 },
  { date: '2024-03-04', followers: 12580 },
  { date: '2024-03-05', followers: 12780 },
  { date: '2024-03-06', followers: 13100 },
  { date: '2024-03-07', followers: 13450 },
  { date: '2024-03-08', followers: 13800 },
  { date: '2024-03-09', followers: 14200 },
  { date: '2024-03-10', followers: 14500 },
  { date: '2024-03-11', followers: 14800 },
  { date: '2024-03-12', followers: 15100 },
  { date: '2024-03-13', followers: 15400 },
  { date: '2024-03-14', followers: 15700 },
];
